export {
  getInfinityArticles,
  getMainArticlesQuery,
  getRecommendedArticlesQuery,
  getCategoriesQuery,
  getRubricsQuery,
  getInfinitySearchArticles,
  getInfinityImportantArticles,
  getImportantArticles,
} from './queries';
